import axios from 'axios'
import { createApp } from 'vue'
import { RECENTLY_VIEWED_COORDINATES } from '~/js/constants/local-storage-keys'
import '~/js/sections/collectionItems'
import { getItemsFromIds } from '~/js/helpers/getProducts'
import FButtonAddToCart from '~/js/components/buttonAddToCart'
import FHeart from '~/js/components/heart'
import FProductsList from '~/js/components/productsList'
import FLinkCard from '~/js/components/linkCard'
import FProductCardStatusLabel from '~/js/components/productCard/statusLabel'
import { LinkItem } from '~/js/models/linkItem'

import '~/js/snippets/recent-items'
import '~/js/templates/index/hashtags'
import {
  favouriteCoordinateHandles,
  favouriteProductHandles,
  isDesktop,
} from '~/js/templates/index/helpers'
const ID_ARTICLE_COORDINATE = 'js-article-coordinate'

const getArticleFromHandle = async (handle) => {
  return await axios
    .get(`/blogs/coordinate/${handle}`, {
      params: {
        view: 'json',
      },
    })
    .then((result) => {
      return result.data
    })
    .catch((e) => {
      console.error(e)
    })
}

const setRecentCoordinates = async (element) => {
  const articleHandle = element.dataset.handle
  const articleHandlesLocalStrage = localStorage.getItem(
    RECENTLY_VIEWED_COORDINATES
  )
  let articleHandles = []
  try {
    articleHandles = JSON.parse(articleHandlesLocalStrage) || []
  } catch (e) {
    console.error(e)
  }

  // localStorageの最近チェックしたコーディネートを更新
  if (articleHandles.includes(articleHandle)) {
    const index = articleHandles.indexOf(articleHandle)
    articleHandles.splice(index, 1)
  }
  articleHandles.unshift(articleHandle)
  localStorage.setItem(
    RECENTLY_VIEWED_COORDINATES,
    JSON.stringify(articleHandles)
  )

  const max = isDesktop() ? 8 : 4
  return await Promise.all(
    articleHandles
      .slice(1, max + 1) // 1個目は現在見ているコーディネートのため、2個目から取得
      .map(async (handle) => {
        return await getArticleFromHandle(handle)
      })
  )
}

document.addEventListener('DOMContentLoaded', async () => {
  const elementProductsList = document.getElementById(ID_ARTICLE_COORDINATE)
  if (!elementProductsList) return

  const productsRef = JSON.parse(
    elementProductsList.dataset.productsRef || '[]'
  )
  const productIds = productsRef.map((ref) => ref.match(/\d*$/)[0])
  const products = await getItemsFromIds(productIds)
  const showArticleProductsList = !!products.length

  const isFavorite = favouriteCoordinateHandles.includes(
    elementProductsList.dataset.handle
  )

  const articles = await setRecentCoordinates(elementProductsList)
  const linkItems = articles
    .filter((v) => v)
    .map((article) => {
      const url = `/blogs/coordinate/${article.handle}`
      const isFavorite = favouriteCoordinateHandles.includes(article.handle)

      return new LinkItem(article, url, isFavorite)
    })
  const showArticleCoordinateRecent = !!linkItems.length

  const productsFiltered = products.filter((v) => v)
  elementProductsList.style.display = null
  createApp({
    name: 'TemplatesArticleCoordinate',
    components: {
      FButtonAddToCart,
      FHeart,
      FLinkCard,
      FProductsList,
      FProductCardStatusLabel,
    },
    data() {
      return {
        favouriteProductHandles,
        isFavorite,
        linkItems,
        isDesktop: isDesktop(),
        products: productsFiltered,
        showArticleCoordinateRecent,
        showArticleProductsList,
      }
    },
    computed: {
      inStockProducts() {
        return this.products
          .filter((product) => product.available)
          .map((product) => ({
            handle: product.handle,
            id: product.variantId,
            image: product.imageUrl,
            productTitle: product.title,
            productTitlePrefix: '',
            quantity: 1,
          }))
      },
      showBulkAddButton() {
        return this.inStockProducts.length >= 2
      },
      textTotalPrice() {
        const formattedTotalPrice = this.products
          .reduce((sum, product) => sum + parseFloat(product.price), 0)
          .toLocaleString()
        return `TOTAL (${this.products.length}商品) : <strong>${formattedTotalPrice}</strong>税込`
      },
      relatedCategoryLinks() {
        const relatedCategoryLinks = []
        this.products.forEach((product) => {
          const handle = product.categoryHandles.reverse()[0]
          const title = product.categoryTitles.reverse()[0]
          if (!relatedCategoryLinks.map((link) => link.handle).includes(handle))
            relatedCategoryLinks.push({ handle, title })
        })
        return relatedCategoryLinks
      },
    },
    methods: {
      onHeartChanged($event) {
        this.isFavorite = $event
      },
      onProductHeartChanged(productHandle) {
        if (this.favouriteProductHandles.includes(productHandle))
          this.favouriteProductHandles.splice(
            this.favouriteProductHandles.indexOf(productHandle),
            1
          )
        else this.favouriteProductHandles.push(productHandle)
      },
    },
    mounted() {
      window.zvRenderReviewSummary(elementProductsList)
    },
  }).mount(elementProductsList)
})
